/**
 * Avoid wiping the center panel when a stale or empty odds response arrives.
 */

export function shouldApplyOddsRequest(requestId, activeRequestId) {
  return requestId === activeRequestId;
}

/**
 * @returns {{ games: Array, keptPrevious: boolean }}
 */
export function resolveOddsFeedUpdate(prevGames, nextGames, { forceEmpty = false } = {}) {
  const prev = Array.isArray(prevGames) ? prevGames : [];
  const next = Array.isArray(nextGames) ? nextGames : [];

  if (forceEmpty) {
    return { games: next, keptPrevious: false };
  }

  if (next.length > 0) {
    return { games: next, keptPrevious: false };
  }

  if (prev.length === 0) {
    return { games: [], keptPrevious: false };
  }

  return { games: prev, keptPrevious: true };
}

export function computeHasMoreFromMeta(meta, loadedCount) {
  if (meta && typeof meta.hasMore === "boolean") {
    return meta.hasMore;
  }
  return Number(loadedCount) > 0;
}
